// Module
var code = "<div class=\"amt-filter\"> <div ng-transclude> </div> </div> ";
// Exports
module.exports = code;